import { render } from "./WeatherWidget.vue?vue&type=template&id=0c671f72"
import script from "./WeatherWidget.vue?vue&type=script&lang=js"
export * from "./WeatherWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__